module.exports = __webpack_public_path__ + "img/duplicate-event.669c6625.svg";